import { render } from "./AntUpload.vue?vue&type=template&id=3e07dfc7"
import script from "./AntUpload.vue?vue&type=script&lang=js"
export * from "./AntUpload.vue?vue&type=script&lang=js"

import "./AntUpload.vue?vue&type=style&index=0&id=3e07dfc7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__